/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  BinaryFile,
  ErrorInfo,
  BmsImportBody,
  BmsImportCount200
} from '.././model'


/**
 * BMSインポート処理
 * @summary BMSインポート処理
 */
export const bmsImport = (
    bmsImportBody: BmsImportBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {const formData = new FormData();
if(bmsImportBody.file !== undefined) {
 formData.append('file', bmsImportBody.file)
 }

    return axios.post(
      `/bms/import`,
      formData,options
    );
  }



    export type BmsImportMutationResult = NonNullable<Awaited<ReturnType<typeof bmsImport>>>
    export type BmsImportMutationBody = BmsImportBody
    export type BmsImportMutationError = AxiosError<ErrorInfo>

    export const useBmsImport = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bmsImport>>, TError,{data: BmsImportBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bmsImport>>, {data: BmsImportBody}> = (props) => {
          const {data} = props ?? {};

          return  bmsImport(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof bmsImport>>, TError, {data: BmsImportBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * BMSインポート処理数取得
 * @summary BMSインポート処理数取得
 */
export const bmsImportCount = (
    bmsHistoryId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BmsImportCount200>> => {
    return axios.get(
      `/bms/${bmsHistoryId}/count`,options
    );
  }


export const getBmsImportCountQueryKey = (bmsHistoryId: number,) => [`/bms/${bmsHistoryId}/count`];

    
export type BmsImportCountQueryResult = NonNullable<Awaited<ReturnType<typeof bmsImportCount>>>
export type BmsImportCountQueryError = AxiosError<ErrorInfo>

export const useBmsImportCount = <TData = Awaited<ReturnType<typeof bmsImportCount>>, TError = AxiosError<ErrorInfo>>(
 bmsHistoryId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof bmsImportCount>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBmsImportCountQueryKey(bmsHistoryId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof bmsImportCount>>> = ({ signal }) => bmsImportCount(bmsHistoryId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof bmsImportCount>>, TError, TData>(queryKey, queryFn, {enabled: !!(bmsHistoryId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

